import { asRecord, asString, asOptionalString } from './common';
import type { SupplierOrderDelivery, DeliveryDocument, DeliveryInvoice } from '../types/supplierOrderDelivery';
const quantity = (v: unknown): number | null => v == null || v === '' || !Number.isFinite(Number(v)) ? null : Number(v);
const array = (v: unknown): unknown[] => Array.isArray(v) ? v : [];
const documents = (v: unknown): DeliveryDocument[] => array(v).map(raw => {
  const r = asRecord(raw);
  return { id: asString(r?.id), number: asString(r?.number), status: asString(r?.status),
    quantity: quantity(r?.quantity), received: r?.received === true, transportIds: array(r?.transportIds).map(value => asString(value)),
    ...(r && 'invoiceId' in r ? { invoiceId: asOptionalString(r.invoiceId) } : {}) };
});
const invoices = (v: unknown): DeliveryInvoice[] | undefined => Array.isArray(v) ? v.map(raw => {
  const r = asRecord(raw); return { id: asString(r?.id), number: asString(r?.number),
    quantity: quantity(r?.quantity), corrected: r?.corrected === true, status: asString(r?.status) || 'APPROVED',
    unreceived: quantity(r?.unreceived), shared: r?.shared === true };
}) : undefined;
export function normalizeSupplierOrderDelivery(raw: unknown): SupplierOrderDelivery {
  const root = asRecord(raw);
  if (!Array.isArray(root?.lines)) throw new Error('Missing supplier delivery lines');
  return { invoices: invoices(root.invoices), lines: root.lines.map((raw: unknown) => {
    const r = asRecord(raw);
    if (!Array.isArray(r?.assignments) || !Array.isArray(r?.documents)) throw new Error('Missing supplier delivery relations');
    return { id: asString(r.id), name: asString(r.name), unit: asString(r.unit),
      ordered: quantity(r.ordered), delivered: quantity(r.delivered), received: quantity(r.received),
      remaining: quantity(r.remaining), unassigned: quantity(r.unassigned),
      documents: documents(r.documents), invoices: invoices(r.invoices),
      assignments: r.assignments.map((raw: unknown) => {
        const a = asRecord(raw);
        if (!Array.isArray(a?.documents)) throw new Error('Missing delivery documents');
        return { id: asString(a.id), routeNumber: asString(a.routeNumber), displayLabel: asOptionalString(a.displayLabel) ?? null,
          loadingAddresses: array(a.loadingAddresses).map(value => asString(value)), deliveryAddresses: array(a.deliveryAddresses).map(value => asString(value)),
          date: asOptionalString(a.date) ?? null, status: asString(a.status),
          quantity: quantity(a.quantity), delivered: quantity(a.delivered), received: quantity(a.received), ambiguous: a.ambiguous === true,
          documents: documents(a.documents), invoices: invoices(a.invoices) };
      }) };
  }) };
}
